import { PropsWithChildren, ReactElement } from 'react';
import * as stylex from '@stylexjs/stylex';
import '../theme/Spaces.stylex';
import { Gap, Padding } from '../theme/Spaces.stylex';
import '../theme/Radius.stylex';
import { CornerRadius } from '../theme/Radius.stylex';
import { Button } from '../actions/Button';
import type { Button_routerOptions as RouterOptions } from '../../externals/ReactAria.gen';
import { type IconName } from '../images-and-icons/Icon';
import { CanarySeparator } from './CanarySeparator';
import { CanaryCardHeader, CanaryCardTitle } from './CanaryCard';
export type CardInfoSwapProps = PropsWithChildren & {
  title?: string;
  headerElement?: ReactElement;
  headerEndElement?: ReactElement;
  minWidth?: string;
  grow?: boolean;
};
export type CanaryCardInfoSwapHeaderButtonProps = {
  tooltipText?: string;
  label?: string;
  icon?: IconName;
  href: string;
  routerOptions?: RouterOptions;
};
const styles = {
  root: {
    "display-k1xSpc": "display-xrvj5dj",
    "flex-kUk6DE": "flex-x98rzlu",
    "gap-kOIVth": "gap-x1rb97w9",
    "backgroundColor-kWkggS": "backgroundColor-x12peec7",
    "borderRadius-kaIpWk": "borderRadius-x1qd5jr3",
    "padding-kmVPX3": "padding-xzp7fdy",
    $$css: "wino-gc:src/resources/layout-and-structure/CanaryCardInfoSwap.tsx:30"
  },
  rootProps: (minWidth: string) => [{
    "minWidth-k7Eaqz": minWidth != null ? "minWidth-xkj4a21" : minWidth,
    $$css: "wino-gc:src/resources/layout-and-structure/CanaryCardInfoSwap.tsx:38"
  }, {
    "--x-minWidth": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(minWidth)
  }],
  grow: {
    "minHeight-kAzted": "minHeight-x2lwn1j",
    "overflow-kVQacm": "overflow-xb3r6kr",
    $$css: "wino-gc:src/resources/layout-and-structure/CanaryCardInfoSwap.tsx:41"
  }
};
export function CanaryCardInfoSwapHeaderButton({
  tooltipText,
  label,
  icon,
  href,
  routerOptions
}: CanaryCardInfoSwapHeaderButtonProps): ReactElement {
  return <div className="display-x3nfvp2 alignItems-x6s0dn4 justifyContent-xl56j7k flexShrink-x2lah0s width-xezivpi height-xlup9mm overflow-x1rea2x4" data-style-src="wino-gc:src/resources/layout-and-structure/CanaryCardInfoSwap.tsx:63">
      <Button icon={icon} label={label} variant="subtle" size="small" bold={false} tooltipText={tooltipText} href={href} routerOptions={routerOptions} />
    </div>;
}
export function CanaryCardInfoSwap({
  children,
  title,
  headerElement,
  headerEndElement,
  minWidth,
  grow = false
}: CardInfoSwapProps): ReactElement {
  return <div {...stylex.props(styles.root, styles.rootProps(minWidth ?? ''), grow && styles.grow)}>
      {title || headerElement || headerEndElement ? <CanaryCardHeader>
          <div className="display-x78zum5 alignItems-x6s0dn4 flex-x98rzlu minWidth-xeuugli" data-style-src="wino-gc:src/resources/layout-and-structure/CanaryCardInfoSwap.tsx:52">
            {title ? <CanaryCardTitle>{title}</CanaryCardTitle> : null}
            {title && headerElement && <CanarySeparator size="auto" spacing="s" />}
            {headerElement}
          </div>
          {headerEndElement ? <div className="display-x78zum5 alignItems-x6s0dn4 marginLeft-x8x9d4c" data-style-src="wino-gc:src/resources/layout-and-structure/CanaryCardInfoSwap.tsx:58">{headerEndElement}</div> : null}
        </CanaryCardHeader> : null}
      {children && <div {...{
      0: {
        className: "overflow-xb3r6kr display-x78zum5 flexDirection-xdt5ytf flex-x98rzlu gap-x7dls1a",
        "data-style-src": "wino-gc:src/resources/layout-and-structure/CanaryCardInfoSwap.tsx:45"
      },
      1: {
        className: "display-x78zum5 flexDirection-xdt5ytf flex-x98rzlu gap-x7dls1a minHeight-x2lwn1j overflow-xb3r6kr",
        "data-style-src": "wino-gc:src/resources/layout-and-structure/CanaryCardInfoSwap.tsx:45; wino-gc:src/resources/layout-and-structure/CanaryCardInfoSwap.tsx:41"
      }
    }[!!grow << 0]}>{children}</div>}
    </div>;
}